<template>
  <Modal
    class="outer_box"
    title="在线预览"
    :mask-closable="false"
    :width="900"
    :transfer="false"
    :value="true"
    :footer-hide="true"
    @on-cancel="$emit('input',false)"
  >
    <!-- 因为旋转是在中心点旋转的,而放大缩小是在左上角 -->
    <!-- 所以给图片的父元素加上放大缩小 -->
    <!-- 给图片加上旋转 -->
    <div class="img_box" :style="{transform:'scale('+multiples+')',transformOrigin:'top left'}">
      <img :src="preView.imgSrc" alt :style="{transform:'rotateZ('+deg+'deg)'}" v-drag />
    </div>
    <div class="previewBtn">
      <!-- 点击时旋转90度 -->
      <div @click="magnify">
        <img src="@/assets/img/fangda.png" alt />
      </div>
      <!-- <i class="el-icon-circle-plus" @click="magnify"></i> -->
      <!-- 缩小0.25 -->
      <div @click="shrink">
        <img src="@/assets/img/suoxiao.png" alt />
      </div>
      <!-- <i class="el-icon-remove" @click="shrink"></i> -->
      <!-- 放大0.25 -->
      <div @click="rotate">
        <img src="@/assets/img/xuanzhuan.png" alt />
      </div>
      <!-- <i class="el-icon-refresh-right" @click="rotate"></i> -->
    </div>
  </Modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    preView: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      deg: 0,
      multiples: 1
    };
  },
  methods: {
    // 放大
    magnify() {
      if (this.multiples >= 3) {
        return;
      }
      this.multiples += 0.25;
    },
    // 缩小
    shrink() {
      if (this.multiples <= 0.5) {
        return;
      }
      this.multiples -= 0.25;
    },
    // 旋转
    rotate() {
      this.deg += 90;
      if (this.deg >= 360) {
        this.deg = 0;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.outer_box {
  position: relative;
  // ::v-deep .ivu-modal-body {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  // }
  // .img_box {
  //   width: 852px;
  //   height: 479px;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
  .img_box {
    // width: 852px;
    max-width: 540px;
    // height: 479px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
      -ms-interpolation-mode: nearest-neighbor;
    }
  }
  .previewBtn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 168px;
    height: 40px;
    background: #2f4061;
    border-radius: 28px;
    opacity: 0.75;
    position: absolute;
    z-index: 99;
    bottom: 30px;
    left: 373px;
    > div {
      width: 24px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>